import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { backendAuthApiRef } from '@internal/plugin-neo4j-auth-common';

import { PermissionElevationRestApi } from './apis';
import { PLUGIN_ID } from './const';
import { permissionElevationApiRef } from './types';

const permissionElevationApi = ApiBlueprint.make({
  name: 'permission-elevation-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: permissionElevationApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          backendAuthApi: backendAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, backendAuthApi }) =>
          new PermissionElevationRestApi({
            discoveryApi,
            fetchApi,
            backendAuthApi,
          }),
      }),
    ),
});

export const neo4JPermissionElevationPlugin = createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  extensions: [permissionElevationApi],
  pluginId: PLUGIN_ID,
});
